import { Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';

@Component({
  selector: 'lfwms-time-mask',
  templateUrl: './time-mask.component.html',
  styleUrls: ['./time-mask.component.css']
})
export class TimeMaskComponent implements OnInit {

  @Input() public params: any;
  @Input() public currentRow: any;
  @Input() public keyEventHandler: any;

  @Output() public onValueChanged: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('primeFocusInput') primeFocusInput: any;

  constructor() {
  }

  public ngOnInit() {

  }

  public validateTimeEntered(timeEntered) {
    const pattern = new RegExp(/^(([01][0-9]|2[0-3])h)|(([01][0-9]|2[0-3]):[0-5][0-9])$/);
    console.log('test', pattern.test(timeEntered));
    this.params.value.cVal = pattern.test(timeEntered) ? timeEntered : '00:00';
  }

  public valueChanged(event) {
    this.onValueChanged.emit(event);
  }

  public onTextFocus() {
    this.primeFocusInput.inputViewChild.nativeElement.focus();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/time-mask/time-mask.component.ts